import type { VoidFunctionComponent } from 'react';

import { Action, ResourceType } from '../../../../../typings/permissions';
import { isOrgInFreeTier } from '../../../../helpers/subscriptions';
import useHasPermission from '../../../../shared/permissions/useHasPermission';

import { SubscriptionBannerUpgradeWithDetails } from './SubscriptionBannerUpgradeWithDetails';

const SubscriptionBannerReportPage:VoidFunctionComponent = () => {
  const hasPermission = useHasPermission();
  const hasAccessToBilling = hasPermission({
    action: Action.Edit,
    resourceType: ResourceType.OrganizationBillingSettings,
  });
  const shouldDisplayBanner = (
    hasAccessToBilling &&
    isOrgInFreeTier()
  );

  if (!shouldDisplayBanner) {
    return null;
  }

  return <SubscriptionBannerUpgradeWithDetails />;
};

export default SubscriptionBannerReportPage;
